/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthIdRequest
 */
export interface AuthIdRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthIdRequest
     */
    auth_id: string;
}

/**
 * Check if a given object implements the AuthIdRequest interface.
 */
export function instanceOfAuthIdRequest(value: object): value is AuthIdRequest {
    if (!('auth_id' in value) || value['auth_id'] === undefined) return false;
    return true;
}

export function AuthIdRequestFromJSON(json: any): AuthIdRequest {
    return AuthIdRequestFromJSONTyped(json, false);
}

export function AuthIdRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthIdRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'auth_id': json['auth_id'],
    };
}

export function AuthIdRequestToJSON(json: any): AuthIdRequest {
    return AuthIdRequestToJSONTyped(json, false);
}

export function AuthIdRequestToJSONTyped(value?: AuthIdRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'auth_id': value['auth_id'],
    };
}

